/* ============================================
   BYTE-FRANCHISE-APPLICATION.JS
   Merges franchise fields into Shopify contact[name] and contact[body] before submit.
   Body is plain text (label line, value line, blank line). HTML is stripped by Shopify
   contact emails, which caused a single run-on line if we used <strong>/<p>.
   ============================================ */

if (!customElements.get('byte-franchise-application')) {
  class ByteFranchiseApplication extends HTMLElement {
    #form;
    #nameField;
    #bodyField;
    #firstNameField;
    #lastNameField;
    #boundSubmit;

    connectedCallback() {
      this.#form = this.querySelector('form');
      if (!this.#form) return;

      this.#nameField = this.#form.querySelector('[name="contact[name]"]');
      this.#bodyField = this.#form.querySelector('[name="contact[body]"]');
      this.#firstNameField = this.#form.querySelector('[data-franchise-field="first_name"]');
      this.#lastNameField = this.#form.querySelector('[data-franchise-field="last_name"]');

      this.#boundSubmit = this.#handleSubmit.bind(this);
      this.#form.addEventListener('submit', this.#boundSubmit);
    }

    disconnectedCallback() {
      this.#form?.removeEventListener('submit', this.#boundSubmit);
    }

    #handleSubmit() {
      if (!this.#nameField || !this.#bodyField) return;

      const first = this.#firstNameField?.value.trim() ?? '';
      const last = this.#lastNameField?.value.trim() ?? '';
      this.#nameField.value = [first, last].filter(Boolean).join(' ').trim();

      const heading = this.dataset.bodyHeading || '';
      const parts = [];

      if (heading) {
        parts.push(` ${heading}: `);
        parts.push('');
      }

      const bodySources = this.#form.querySelectorAll('[data-franchise-field]');

      for (const el of bodySources) {
        const key = el.dataset.franchiseField;
        if (key === 'first_name' || key === 'last_name') continue;

        const label = el.dataset.franchiseLabel || key;
        const raw = 'value' in el ? el.value : '';
        const displayVal = raw.trim() || '—';

        parts.push(`[ ${label} ]`);
        parts.push(displayVal);
        parts.push('');
      }

      this.#bodyField.value = parts.join('\n').replace(/\n+$/, '');
    }
  }

  customElements.define('byte-franchise-application', ByteFranchiseApplication);
}
